import { useEffect, useState } from "react";
import api from "../services/api";
import { FaPlus, FaCashRegister } from "react-icons/fa";

function CaixaDiario(){
  
  const [caixas, setCaixas] = useState([]);
  const [valorInicial, setValorInicial] = useState("");
  const [movimentos, setMovimentos] = useState([]);
  const [caixaAbertoId, setCaixaAbertoId] = useState(null);

  const load = async ()=>{
    const res = await api.get("/caixa");
    setCaixas(res.data);
  };

  useEffect(()=>{ load(); },[]);

  const abrirCaixa = async ()=>{
    const usuario = JSON.parse(localStorage.getItem("usuario"));
    if(!valorInicial) return;
    const res = await api.post("/caixa/abrir", { usuario_id: usuario.id, valor_inicial: valorInicial });
    setCaixaAbertoId(res.data.id);
    setValorInicial("");
    load();
  };

  const fecharCaixa = async (id, valor_final)=>{
    await api.post("/caixa/fechar", { id, valor_final });
    setCaixaAbertoId(null);
    load();
  };

  const addMovimento = async (tipo, descricao, valor)=>{
    if(!caixaAbertoId) return;
    await api.post("/caixa/movimento", { caixa_id: caixaAbertoId, tipo, descricao, valor });
    load();
  };

  return (
    <div className="page-container">
      <h2><FaCashRegister /> Caixa Diário</h2>

      {!caixaAbertoId && (
        <div className="form-box">
          <input placeholder="Valor Inicial" value={valorInicial} onChange={e=>setValorInicial(e.target.value)}/>
          <button onClick={abrirCaixa}><FaPlus /> Abrir Caixa</button>
        </div>
      )}

      {caixaAbertoId && (
        <div className="form-box">
          <input placeholder="Descrição" id="desc"/>
          <input placeholder="Valor" id="val"/>
          <select id="tipo">
            <option value="ENTRADA">ENTRADA</option>
            <option value="SAIDA">SAIDA</option>
          </select>
          <button onClick={()=>{
            const desc = document.getElementById("desc").value;
            const val = document.getElementById("val").value;
            const tipo = document.getElementById("tipo").value;
            addMovimento(tipo, desc, val);
          }}><FaPlus /> Adicionar</button>

          <button onClick={()=>fecharCaixa(caixaAbertoId, 0)}>Fechar Caixa</button>
        </div>
      )}

      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Data</th>
            <th>Operador</th>
            <th>Valor Inicial</th>
            <th>Entradas</th>
            <th>Saídas</th>
            <th>Valor Final</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {caixas.map(c=>(
            <tr key={c.id}>
              <td>{c.id}</td>
              <td>{c.data?.split("T")[0]}</td>
              <td>{c.operador}</td>
              <td>{c.valor_inicial}</td>
              <td>{c.total_entradas}</td>
              <td>{c.total_saidas}</td>
              <td>{c.valor_final}</td>
              <td>{c.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CaixaDiario;
